import { makeStyles } from 'tss-react/mui'

export default makeStyles()({
  container: {
    display: 'flex',
    flexGrow: '1',
    maxWidth: '100vw',
    boxSizing: 'border-box',
  },
})
